module.exports = __webpack_public_path__ + "static/Onlay lower after-fb5f44308ef1dc05e693487f7546af62.jpg";